const pageNameKey = "timezoneSelectorWithSearch";

export const timezoneSelectorWithSearchEn = {
  [pageNameKey]: {
    timezoneLabel: "Timezone",
    searchPlaceholder: "Search Timezone",
    noResults: "No results found",
  },
};

export const timezoneSelectorWithSearchPtBr = {
  [pageNameKey]: {
    timezoneLabel: "Fuso horário",
    searchPlaceholder: "Pesquisar fuso horário",
    noResults: "Nenhum resultado encontrado",
  },
};

export const timezoneSelectorWithSearchDe = {
  [pageNameKey]: {
    timezoneLabel: "Zeitzone",
    searchPlaceholder: "Zeitzone suchen",
    noResults: "Keine Ergebnisse gefunden",
  },
};

export const timezoneSelectorWithSearchZhHans = {
  [pageNameKey]: {
    timezoneLabel: "时区",
    searchPlaceholder: "搜索时区",
    noResults: "未找到结果",
  },
};

export const timezoneSelectorWithSearchIt = {
  [pageNameKey]: {
    timezoneLabel: "Fuso orario",
    searchPlaceholder: "Cerca Fuso Orario",
    noResults: "Nessun risultato trovato",
  },
};

export const timezoneSelectorWithSearchEs = {
  [pageNameKey]: {
    timezoneLabel: "Zona horaria",
    searchPlaceholder: "Buscar zona horaria",
    noResults: "No se encontraron resultados",
  },
};

export const timezoneSelectorWithSearchNl = {
  [pageNameKey]: {
    noResults: "Geen resultaten gevonden",
    searchPlaceholder: "Tijdzone zoeken",
    timezoneLabel: "Tijdzone",
  },
};

export const timezoneSelectorWithSearchTr = {
  [pageNameKey]: {
    noResults: "Sonuç bulunamadı",
    searchPlaceholder: "Arama Saat Dilimi",
    timezoneLabel: "Saat dilimi",
  },
};
